import React, { useMemo } from 'react'

import './christmas.scss'

export const Christmas = () => {

    const isMarch = useMemo(() => {
        const date = new Date()
        const day = date.getDate()
        const month = date.getMonth() + 1

        return (month === 2 && day >= 15) || (month === 3 && day <= 30)
            
    },[])

    const isXMass = useMemo(() => {
        const date = new Date()
        const day = date.getDate()
        const month = date.getMonth() + 1

        return (month === 11 && day >= 15) || (month === 12) || (month === 1 && day <= 15)    
            
    },[])

    if (isMarch) {
        return (
            <div className='snow'>
                <img src='/images/FlowerPetal.png' alt='snowflake' className="snowflake"/>
                <img src='/images/FlowerPetal1.png' alt='snowflake' className="snowflake1"/>
                <img src='/images/FlowerPetal.png' alt='snowflake' className="snowflake2"/>
                <img src='/images/FlowerPetal1.png' alt='snowflake' className="snowflake3"/>
                <img src='/images/FlowerPetal.png' alt='snowflake' className="snowflake4"/>
                <img src='/images/FlowerPetal1.png' alt='snowflake' className="snowflake5"/>
                <img src='/images/FlowerPetal.png' alt='snowflake' className="snowflake6"/>
                <img src='/images/FlowerPetal1.png' alt='snowflake' className="snowflake7"/>
                <img src='/images/FlowerPetal.png' alt='snowflake' className="snowflake8"/>
                <img src='/images/FlowerPetal1.png' alt='snowflake' className="snowflake9"/>
            </div>
        )
    }

    if (isXMass) {
        return (
            <div className='snow'>
            <img src='/images/gift-box-black.png' alt='snowflake' className="snowflake"/>
            <img src='/images/snowflake-white1.png' alt='snowflake' className="snowflake1"/>
            <img src='/images/snowflake-white.png' alt='snowflake' className="snowflake2"/>
            <img src='/images/snowflake-white1.png' alt='snowflake' className="snowflake3"/>
            <img src='/images/gift-box-gold.png' alt='snowflake' className="snowflake4"/>
            <img src='/images/gift-box-red.png' alt='snowflake' className="snowflake5"/>
            <img src='/images/snowflake-white.png' alt='snowflake' className="snowflake6"/>
            <img src='/images/snowflake-white1.png' alt='snowflake' className="snowflake7"/>
            <img src='/images/snowflake-white.png' alt='snowflake' className="snowflake8"/>
            <img src='/images/snowflake-white1.png' alt='snowflake' className="snowflake9"/>
        </div>
        )
    }

    return null
}